/**
 * i18n Configuration
 * Supported locales: en (English), pt (Portuguese), es (Spanish)
 */

export const locales = ['en', 'pt', 'es'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  pt: 'Português',
  es: 'Español',
};

/**
 * CiC (Cyncly Content) locale for each site locale. It drives the CiC browser
 * client's `contentPlatform.locale`, which decides the language of facet and
 * value labels, and selects the `localizations/localizations.<locale>.json`
 * dictionary. CiC expects the `xx-YY` form; lowercase it for the file name.
 */
export const cicLocales: Record<Locale, string> = {
  en: 'en-US',
  pt: 'pt-BR',
  es: 'es-MX',
};

/** Maps a site locale to its CiC locale, defaulting to English for unknowns. */
export function toCicLocale(locale?: string): string {
  const normalized = (locale ?? '').toLowerCase() as Locale;
  return cicLocales[normalized] ?? cicLocales[defaultLocale];
}
